import {
  NotecardCommand,
  NotecardDeviceConnection,
} from "../NotecardDevice/NotecardDeviceConnection";
import { CommandResult } from "../DeviceConnection";
import { hintMarkdownLine, messageLine } from "../HistoryLine";

/* eslint-disable class-methods-use-this */

export default class ModemTest implements NotecardCommand {
  COMMANDS = ["modem-test", "modem-test-test"];

  name = "modem-test";

  triggeredBy(request: string) {
    return this.COMMANDS.includes(request.trim().split(" ")[0]);
  }

  copy(): ModemTest {
    return new ModemTest();
  }

  async perform(
    deviceConnection: NotecardDeviceConnection,
    request: string,
  ): Promise<CommandResult> {
    deviceConnection.disableBackgroundTasks();
    await deviceConnection.write(`${request}\n`);
    return {
      history: [
        messageLine("Background tasks disabled until next connection."),
        hintMarkdownLine("To exit modem-test, power cycle the Notecard"),
      ],
    };
  }
}
